import React, { useState, useEffect } from 'react';
import { useBreakpoints } from '@tamagoshi/core/MediaQuery';
import Accordion from '@tamagoshi/core/Accordion';
import { getTranslations } from '@translations';
import { getFooterContext } from '@context';
import Navigation from '../Navigation';
import More from '../More';
import Newsletter from '../Newsletter';
import AccordionItem from './AccordionItem';

import styles from './styles/index.module.scss';

const FooterAccordion = () => {
  const breakpoints = useBreakpoints();
  const translations = getTranslations();
  const { emailAddress } = getFooterContext();
  const [isClient, setIsClient] = useState(false);
  const isVisible = isClient && (breakpoints.sm || breakpoints.xs);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <Accordion size="xl" className={styles.mobileBlock}>
      <AccordionItem
        isVisible={isVisible}
        title={translations('footer.contact.newsletter.title')}
        subTitle={translations('footer.contact.newsletter.sub.title')}
        id="newsletter"
      >
        <Newsletter emailAddress={emailAddress} />
      </AccordionItem>
      <AccordionItem
        isVisible={isVisible}
        title={translations('footer.navigation.title')}
        subTitle={translations('footer.navigation.sub.title')}
        id="navigation"
      >
        <Navigation />
      </AccordionItem>
      <AccordionItem
        isVisible={isVisible}
        title={translations('footer.more.title')}
        subTitle={translations('footer.more.sub.title')}
        id="more"
      >
        <More />
      </AccordionItem>
    </Accordion>
  );
};

FooterAccordion.displayName = 'FooterAccordion';

export default FooterAccordion;
